/** Browser entry point. Kept separate from `main.ts` so boot stays testable. */
import { bootGame } from './main';

bootGame();
